module.exports = __webpack_public_path__ + "static/img/RW.b5336349.png";